const state = () => ({
    loading: true,
    data: []
})

// getters
const getters = {}

// actions
const actions = {
    // get records
    async get({state, commit}, {id} = {}) {
        commit('setLoading', true)

        const res = await this._vm.axios.get(this._vm.endpoint.get('library_directory_tree'))

        const {data} = res.data
        commit('setData', data)
        commit('setLoading', false)
    },
}

// mutations
const mutations = {
    setData(state, data) {
        state.data = data
    },
    setLoading(state, loading) {
        state.loading = loading
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
